export default {"src":"/_next/static/media/CNS.3e8c5137.svg","height":342,"width":513,"blurWidth":0,"blurHeight":0};